type Column<T> = {
	id: string
	header: string
	accessor: (item: T) => string | number | Date | null
}

type SortOrder = "asc" | "desc"

export interface SortableColumn {
  id: string
  header: string
	accessor: (row: unknown) => string | null
}


const useTableSort = <T>(
	data: T[],
	columns: Column<T>[],
	sortBy: string,
	sortOrder: SortOrder
) => {
	const sortableColumns = columns.filter((column) => column.accessor !== null)
	const getSortValue = (element: T, field: string) => {
		const column = sortableColumns.find((col) => col.id === field)
		if (!column) return ""

		const value = column.accessor(element)

		if (value instanceof Date) {
			return value.getTime()
		}

		if (typeof value === "string") {
			return value.toLowerCase()
		}

		return value
	}

	const sortedData = [...data].sort((a, b) => {
		const aValue = getSortValue(a, sortBy) || 0
		const bValue = getSortValue(b, sortBy) || 0

		if (aValue === bValue) return 0
		const comparison = aValue > bValue ? 1 : -1
		return sortOrder === "asc" ? comparison : -comparison
	})

	return sortedData
}

export default useTableSort
